import { Box, Tab, Tabs } from '@mui/material';
import { useStore } from 'mobx/StoreContext';
import { observer } from 'mobx-react-lite';
import { JobQueueTableType } from 'pages/iPriseV2/common/enum/TeamUserRoles';
import CommonJobQueueTable from 'pages/iPriseV2/common/JobQueueTable';
import React, { useCallback } from 'react';

import ColumnsSidebar from './ColumnsSidebar';

const BenchQueueTable: React.FC = () => {
  const { businessHeadJobQueueService } = useStore();
  const {
    benchSubTab,
    searchTerm,
    selectedTeam,
    selectedSort,
    percentage,
    benchAllJobsPage,
    benchAllJobsRowsPerPage,
    benchMyJobsPage,
    benchMyJobsRowsPerPage,
    benchOverduePage,
    benchOverdueRowsPerPage,
    benchClosedPage,
    benchClosedRowsPerPage,
  } = businessHeadJobQueueService;

  const handleBenchSubTabChange = useCallback(
    (_event: React.SyntheticEvent, newValue: number) => {
      businessHeadJobQueueService.setBenchSubTab(newValue);
    },
    [businessHeadJobQueueService],
  );

  return (
    <Box className="table-container-with-sidebar">
      <Box className="table-main-content">
        <Box className="sub-tabs-container">
          <Box className="sub-tabs-wrapper">
            <Tabs
              value={benchSubTab}
              onChange={handleBenchSubTabChange}
              className="sub-tabs"
              variant="scrollable"
              allowScrollButtonsMobile
              TabIndicatorProps={{
                className: 'sub-tab-indicator',
              }}>
              <Tab label="All Jobs" className="sub-tab" />
              <Tab label="My Jobs" className="sub-tab" />
              <Tab label="Overdue" className="sub-tab" />
              <Tab label="Closed" className="sub-tab" />
            </Tabs>
          </Box>
        </Box>

        {benchSubTab === 0 && (
          <CommonJobQueueTable
            tableType={JobQueueTableType.BH_BQ_ALL_JOBS}
            status=""
            queryKey="bh-bench-queue-all-jobs"
            page={benchAllJobsPage}
            rowsPerPage={benchAllJobsRowsPerPage}
            onPageChange={(p) =>
              businessHeadJobQueueService.setBenchAllJobsPage(p)
            }
            onRowsPerPageChange={(r) =>
              businessHeadJobQueueService.setBenchAllJobsRowsPerPage(r)
            }
            popperId="skills-popper-bh-bench-all"
            isBenchQueue={true}
            screenStatus=""
            searchTerm={searchTerm}
            selectedTeam={selectedTeam}
            selectedSort={selectedSort}
            percentage={percentage}
          />
        )}
        {benchSubTab === 1 && (
          <CommonJobQueueTable
            tableType={JobQueueTableType.BH_BQ_MY_JOBS}
            status=""
            queryKey="bh-bench-queue-my-jobs"
            page={benchMyJobsPage}
            rowsPerPage={benchMyJobsRowsPerPage}
            onPageChange={(p) =>
              businessHeadJobQueueService.setBenchMyJobsPage(p)
            }
            onRowsPerPageChange={(r) =>
              businessHeadJobQueueService.setBenchMyJobsRowsPerPage(r)
            }
            popperId="skills-popper-bh-bench-my"
            isBenchQueue={true}
            benchStatus="published"
            searchTerm={searchTerm}
            selectedTeam={selectedTeam}
            selectedSort={selectedSort}
            percentage={percentage}
          />
        )}
        {benchSubTab === 2 && (
          <CommonJobQueueTable
            tableType={JobQueueTableType.BH_BQ_OVERDUE}
            status=""
            queryKey="bh-bench-queue-overdue"
            page={benchOverduePage}
            rowsPerPage={benchOverdueRowsPerPage}
            onPageChange={(p) =>
              businessHeadJobQueueService.setBenchOverduePage(p)
            }
            onRowsPerPageChange={(r) =>
              businessHeadJobQueueService.setBenchOverdueRowsPerPage(r)
            }
            popperId="skills-popper-bh-bench-overdue"
            isBenchQueue={true}
            screenStatus="overdue"
            searchTerm={searchTerm}
            selectedTeam={selectedTeam}
            selectedSort={selectedSort}
            percentage={percentage}
          />
        )}
        {benchSubTab === 3 && (
          <CommonJobQueueTable
            tableType={JobQueueTableType.BH_BQ_CLOSED}
            status=""
            queryKey="bh-bench-queue-closed"
            page={benchClosedPage}
            rowsPerPage={benchClosedRowsPerPage}
            onPageChange={(p) =>
              businessHeadJobQueueService.setBenchClosedPage(p)
            }
            onRowsPerPageChange={(r) =>
              businessHeadJobQueueService.setBenchClosedRowsPerPage(r)
            }
            popperId="skills-popper-bh-bench-closed"
            isBenchQueue={true}
            screenStatus="closed"
            searchTerm={searchTerm}
            selectedTeam={selectedTeam}
            selectedSort={selectedSort}
            percentage={percentage}
          />
        )}
      </Box>
      <ColumnsSidebar />
    </Box>
  );
};

export default observer(BenchQueueTable);
